import { useI18n } from "@/i18n/I18nContext";
import { maintenanceMessage, useMaintenance } from "./maintenanceStore";

/**
 * Shown while only writes are refused: the app still works for reading, and the
 * reason a change fails is on screen before the user tries one.
 */
export function MaintenanceBanner() {
  const status = useMaintenance();
  const { locale, t } = useI18n();
  if (!status.enabled || status.blocksReads) return null;
  const message = maintenanceMessage(status, locale);
  return (
    <div role="status" className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-950">
      <strong className="font-semibold">{t("maintenance.readOnlyTitle")}</strong>{" "}
      {message || t("maintenance.readOnlyBody")}
    </div>
  );
}
